const ArticleBuilderPage: React.FC = () => {
  return (
    <>
      <p>Coming Soon</p>
    </>
  );
};

export default ArticleBuilderPage;
